import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IScanPackageToAddData } from '../../../types';

/**
 * This is to track the mutation key for scan package to add it to an inbound
 * transaction
 */
const MUT_SCAN_PACKAGE_TO_ADD = 'scan-package-to-add-mutation-key';

interface IUpdateBidMutationParam {
  onSuccess: (updatedBidsData: IScanPackageToAddData) => void;
  onError: (err: IApiError) => void;
}

/**
 * React Query mutation function for adding package from to a transaction
 */
export const useScanPackageToAddMutation = ({
  onSuccess,
  onError,
}: IUpdateBidMutationParam) => {
  const { isPending, isError, isSuccess, error, data, mutate, reset } =
    useMutation({
      mutationKey: [MUT_SCAN_PACKAGE_TO_ADD],
      networkMode: 'always',
      mutationFn: INV_MGMT_SERVICE_API.scanPackageToAdd,
      onSuccess,
      onError,
    });

  return {
    data,
    error,
    isError,
    isPending,
    isScanPackageSuccess: isSuccess,
    resetScanPackageToAdd: reset,
    scanPackageToAdd: mutate,
  };
};
